import React, { useRef, useState } from "react";
import { Form, Button, Card, Alert } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";
import { Link, useHistory } from "react-router-dom";

export default function Login() {
  const emailRef = useRef();
  const passwordRef = useRef();
  const { login } = useAuth();
  const [error, setError] = useState("");
  const history = useHistory();

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setError("");
      await login(emailRef.current.value, passwordRef.current.value);
      history.push("/storage");
    } catch {
      setError("Failed to log in");
    }
  }
  return (
    <div>
      <Card>
        <Card.Body>
          <h2 className="text-center mb-4">Login</h2>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group id="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                ref={emailRef}
                required
                autoComplete="on"
              />
            </Form.Group>
            <Form.Group id="password">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Password"
                autoComplete="on"
                ref={passwordRef}
                required
              />
            </Form.Group>
            <Button
              className="w-100 text-center mt-2"
              type="submit"
            >
              Login
            </Button>
            <div className="w-100 text-center mt-2"></div>
          </Form>
          <div className="w-100 text-center mt-2">
            <Link to="/forgot-password">Forgot password</Link>
          </div>

        </Card.Body>
      </Card>
      <div className="w-100 text-center mt-2">
        Need an account?<Link to="/signup">Sign up</Link>
      </div>
    </div>
  );
}
